import React from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigation } from '@react-navigation/native';
import { NativeStackScreenProps } from '@react-navigation/native-stack';

import BetrAnalytics from '@/feature/analytics/analytics';
import { AnalyticsEvent } from '@/feature/analytics/constants';
import { trackRG } from '@/feature/analytics/trackRudderStackEvent';
import { useSocialWalletTranslation } from '@/hooks/use-social-wallet-translation';
import { RootStackParamList } from '@/navigation/types';

import { LimitsModal } from '../components/LimitModal';
import { LIMIT_DURATION } from '../constants';
import { useAddLimitErrorMessage } from '../hooks/use-add-limit-error-message';
import { useAddUserLimits } from '../hooks/use-add-user-limits';

type ScreenProps = NativeStackScreenProps<RootStackParamList, 'DepositLimitAdd'>;

export const DepositLimitAdd = ({ route: { params } }: ScreenProps) => {
    const { t } = useTranslation('rg');
    const tSocialWallet = useSocialWalletTranslation('rg');
    const { mutate: addLimit, isPending } = useAddUserLimits();
    const navigation = useNavigation();

    const { duration } = params;
    const { getErrorMessage } = useAddLimitErrorMessage(duration, 'DEPOSIT');
    const errorMessageHandler = (value: number) => getErrorMessage(value);

    const handlePress = (amount: number) => {
        addLimit(
            { type: 'DEPOSIT', duration, amount },
            {
                onSuccess: () => {
                    BetrAnalytics.trackProductEvent(AnalyticsEvent.CONFIRM_ADD_DEPOSIT_LIMIT, { duration, amount });
                    trackRG.depositLimitAddScreen(`${duration} Deposit Limit`, {
                        duration,
                        amount,
                    });
                    navigation.goBack();
                },
            }
        );
    };

    const title = tSocialWallet('duration_deposit_limit', {
        duration: LIMIT_DURATION[duration],
    });

    return (
        <LimitsModal
            title={title}
            buttonLabel={t('add_limit')}
            handleButtonPress={handlePress}
            isButtonDisabled={isPending}
            errorMessageHandler={errorMessageHandler}
        />
    );
};
